// extracted by mini-css-extract-plugin
export default {"contenedor":"start_styles_contenedor__YZ9kb","buttonContainer":"start_styles_buttonContainer__Cb+yr"};